<template>
    <div class="mc-dialog" v-if="option.visible">
        <el-dialog
            :visible="option.visible"
            :title="option.title"
            :width="option.style.width"
            :top="option.style.top"
            :show-close="option.style.showClose"
            :modal="option.style.showModal"
            :fullscreen="option.style.isFullscreen"
            :center="option.style.isCenter"
            @close="$_close"
        >
            <slot name="content">
                <div v-html="option.text.replace(/\n/g, '<br/>')"></div>
            </slot>
            <span slot="footer" class="dialog-footer">
                <slot name="footer">
                    <el-button v-if="option.style.showCancel" @click="option.methods.cancel">取 消</el-button>
                    <el-button v-if="option.style.showConfirm" type="primary" @click="option.methods.confirm">确 定</el-button>
                </slot>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "mc-dialog",
        data() {
            return {
                option: {
                    visible: false,
                    title: "提示",
                    text: "",
                    style: {
                        top: '15vh',
                        width: '600px',
                        showClose: true,
                        showModal: true,
                        isCenter: false,
                        isFullscreen: false,
                        showConfirm: true,
                        showCancel: true,
                    },
                    methods: {
                        beforeClose: ()=>{},
                        confirm: ()=>{
                            this.$_close();
                        },
                        cancel: ()=>{
                            this.$_close();
                        },
                    },
                }
            }
        },
        props: {
            dialogOption: {
                type: Object,
                default: ()=>{
                    return {}
                },
            },
        },
        methods: {
            $_handleOption() {
                for(let i in this.dialogOption){
                    if(typeof(this.dialogOption[i]) === "object") {
                        if(this.option[i]) {
                            for(let j in this.dialogOption[i]) {
                                this.option[i][j] = this.dialogOption[i][j];
                            }
                        } else {
                            this.option[i] = this.dialogOption[i];
                        }
                    } else {
                        this.option[i] = this.dialogOption[i]
                    }
                }
            },
            $_close(){
                this.option.visible = false;
                this.$emit('update:dialogOption',this.option);
            },
        },
        mounted(){
            this.$_handleOption();
        },
        watch: {
            dialogOption: {
                handler: function(newVal, oldVal) {
                    this.$_handleOption();
                },
                deep: true,
            }
        }
    }
</script>
